import { createSearchParams, Link } from 'react-router-dom'
import { useCallback } from 'react'

import { PAIR_INFOS } from 'utils/pair-info'
import { LeaderboardPosition } from '../hooks/useLeaderboardPositions'
import { getPositionRangeMax, getPositionRangeMin } from 'modules/MyPositions/utils'
import { NewPositionQueryParams } from '../const'
import { ROUTES } from 'utils/route-constants'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { IconCloneContainer } from './Table'
import { useIsMobile } from 'utils/useIsMobile'
import { IconClone } from 'components/Icons/IconClone'
import { usePostHogEntityAction } from 'utils/usePostHogEntityAction'

export const ClonePositionLink = ({ position }: { position: LeaderboardPosition }) => {
  const isMobile = useIsMobile()
  const { capture } = usePostHogEntityAction()

  const handleLinkClick = useCallback(() => {
    capture('leaderboard:clone_position_click', {
      entity_id: position.positionId,
    })
  }, [capture, position.positionId])

  const pair = PAIR_INFOS.find(
    p =>
      (p.coinX.typeName === position.displayInfo.position.X.typeName &&
        p.coinY.typeName === position.displayInfo.position.Y.typeName) ||
      (p.coinX.typeName === position.displayInfo.position.Y.typeName &&
        p.coinY.typeName === position.displayInfo.position.X.typeName)
  )

  if (!pair) {
    return null
  }

  const isReversedPair = position.displayInfo.position.configInfo.isReversedPair
  const minPrice = getPositionRangeMin(isReversedPair, position.displayInfo, 8)
  const maxPrice = getPositionRangeMax(isReversedPair, position.displayInfo, 8)

  const search = createSearchParams({
    [NewPositionQueryParams.configId]: String(position.displayInfo.position.configInfo.configId),
    [NewPositionQueryParams.minPrice]: String(minPrice),
    [NewPositionQueryParams.maxPrice]: String(maxPrice),
  }).toString()

  return (
    <IconCloneContainer>
      <Link
        to={{
          pathname: `/${ROUTES.LP_VAULTS}/${pair.coinX.displaySymbol}-${pair.coinY.displaySymbol}`,
          search,
        }}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleLinkClick}
      >
        {isMobile ? (
          <IconClone />
        ) : (
          <Tooltip content="Clone position" position="top" tooltipBoxStyles={{ maxWidth: 120, minWidth: 120 }}>
            <IconClone />
          </Tooltip>
        )}
      </Link>
    </IconCloneContainer>
  )
}
